import { memo, useEffect } from 'react';

import clsx from 'clsx';

import type { TConfig } from '@@/interfaces';
import typography from '@@/styles/typography.module.css';

import analytics from '../../analytics';
import Link from '../Link';
import Logo from '../Logo';

import classes from './NotFoundView.module.css';

type TNotFoundView = {
  notFoundPageConfig: TConfig['notFoundPageConfig'];
};

function NotFoundView({ notFoundPageConfig }: TNotFoundView) {
  const { backgroundImgSrc, ctaHref } = notFoundPageConfig;

  useEffect(() => {
    analytics.page();
  }, []);

  return (
    <div
      data-testid="404Page"
      style={{
        backgroundImage: backgroundImgSrc
          ? `url(${backgroundImgSrc})`
          : undefined,
      }}
      className={classes.root}
    >
      <div className={classes.container}>
        <Logo
          overrideClasses={{ root: clsx('NavBar-logo-img', classes.logo) }}
          isLight
        />
        <h1 className={clsx(classes.title, typography.h2)}>404</h1>
        <p className={clsx(typography.h4, classes.subtitle)}>
          {`Ruh roh! The page you're looking for seems to have mysteriously
          disappeared.`}
        </p>
        <p className={clsx(typography.body_2, classes.description)}>
          While we try to solve this mystery, try refreshing this page or click
          the button below to return to the home page.
        </p>

        <Link data-testid="404Page_cta" className={classes.cta} to={ctaHref}>
          Go Home
        </Link>
      </div>
    </div>
  );
}

export default memo(NotFoundView);
